import React, {useState} from "react";
import IconButton from "../components/IconButton";
import {ExitToApp, Person} from "@material-ui/icons";
import FlexBox from "../components/FlexBox";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AvatarWithLabel from "./avatar/AvatarWithLabel";
import {useHistory} from "react-router-dom";
import {useUserContext} from "../context/user-context";
// import { useUserContext } from "../../contexts/user-context";
// import { useToggle } from "../../hooks/useToggle";


const UserBar = () => {

  const history = useHistory(); // Add this line
    const {user, logout} = useUserContext(); // aaaaaaaaaaaaaaaaaaaa

  const useStyles = makeStyles((theme) => ({
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      // Initials are coloured in global.css (.headerCnt__aTag div wins on
      // specificity over anything set from here).
      // Two Georgian letters need a little more room than the single one the
      // desktop bar shows next to the name.
      '@media (max-width: 660px)': {
        width: theme.spacing(4.5),
        height: theme.spacing(4.5),
        fontSize: 14,
      },
    },
    bigAvatar: {
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    text: {
      color: '#000000',
      fontSize: 15,
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: 5,
      marginRight: 5,
      // Same breakpoint the header uses in global.css. The full name still
      // shows in the menu this avatar opens, so nothing is lost.
      '@media (max-width: 660px)': {
        display: 'none',
      },
    },
    menuitem: {
      '&:focus': {
        backgroundColor: theme.palette.common.white,
        '& .MuiListItemIcon-root': {
          color: theme.palette.primary.main,
        },
      },
      justifyContent: "center",
      minWidth: "250px"
    }
  }));

  const classes = useStyles();
  const isNarrow = useMediaQuery('(max-width: 660px)');

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  // Narrow screens show the avatar alone, so one letter is too little to tell
  // two students apart: "ნიკა ზუბიაშვილი" becomes "ნზ".
  const initials = fullName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join("");
  // const {mutateAsync: onUpdate} = useUpdateUser();
  // const {user, logout, userUpdated} = useUserContext();
  // const avatar = user.avatarUrl;
  // const {open: modalOpen, handleOpen: handleModalOpen, handleClose: handleModalClose} = useToggle();
  const [anchorEl, setAnchorEl] = useState(null);
  const imgZipOpts = {
    maxSizeMB: 0.1,
    maxWidthOrHeight: 400,
    useWebWorker: true
  };

  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

    // No avatar image is passed: the Avatar falls back to the first letter
    // of the name, which is what has always been on screen. It used to be
    // handed the Avatar *component* as its src, which React stringified to
    // "[object Object]" and the browser then fetched as a relative URL - a
    // 400 on every page load, and a React warning alongside it.
  return (
    <FlexBox>
        <IconButton color="secondary"
                    component="span"
                    size="small"
                    aria-controls="user-bar-menu"
                    aria-haspopup="true"
                    onClick={handleToggle}
                    icon={<AvatarWithLabel label={fullName}
                                           alt={isNarrow ? initials : undefined}
                                           className="headerAvatar"
                                           classes={classes}/>}/>
        <Menu
            id="user-bar-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
        >
            <MenuItem classes={{root: classes.menuitem}}>
                <ListItemIcon>
                    <Person/>
                </ListItemIcon>
                <ListItemText primary={fullName}/>
            </MenuItem>
            <MenuItem classes={{root: classes.menuitem}} onClick={logout}>
                <ListItemIcon>
                    <ExitToApp/>
                </ListItemIcon>
                <ListItemText primary={"გამოსვლა"}/>
            </MenuItem>
      </Menu>
      {/*{modalOpen && (*/}
      {/*  <UserFormModal*/}
      {/*    open={modalOpen}*/}
      {/*    data={user}*/}
      {/*    modalOpenMode={modalOpenModes.EDIT_MODE}*/}
      {/*    isDataTableModal={false}*/}
      {/*    onClose={handleModalClose}*/}
      {/*  />*/}
      {/*)}*/}
    </FlexBox>
  );
};

export default UserBar;
